import Logo from "../../../../Svg/Logo";
import "./print.css";
import { localizeDate, customerAddress } from "../../../../utils";
import { OldInstallTypeOptions } from "../../../../constants/helperConstants";

const CheckPoint = ({ section, question, index }: any) => {
  return (
    <div
      key={index}
      style={{
        margin: 0
      }}
    >
      <div style={{ paddingLeft: "10px" }}>
        <p style={{ margin: 0, padding: 0 }}> {question?.title}</p>

        <div style={{ display: "flex", gap: 3 }}>
          {question?.choices?.map((choice: any) => (
            <div key={choice} style={{ display: "flex", gap: 3, alignItems: "center" }}>
              <input
                type="checkbox"
                checked={question?.form_response?.response?.split(",")?.includes(choice)}
              />
              <p key={choice} style={{ margin: 0, padding: 0 }}>
                {choice}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Response = ({ section, question, index }: any) => {
  const response = question?.form_response?.response;

  return (
    <p
      key={index}
      style={{
        margin: 0
      }}
    >
      <div style={{ textAlign: "center" }}>
        {["true", "false"].includes(response)
          ? response === "true"
            ? "Yes"
            : "No"
          : question?.form_response?.response
            ? question?.form_response?.response
            : "-"}
      </div>
    </p>
  );
};

const Comment = ({ section, question, index }: any) => {
  return (
    <div key={index}>
      <div style={{ textAlign: "center" }}>
        <p>
          {question?.form_response?.images &&
            question?.form_response?.images?.map((image: any) => (
              <a key={image?.url} href={image?.url} target="_blank" rel="noreferrer">
                Image
              </a>
            ))}
        </p>
        <p>
          {question?.form_response?.videos &&
            question?.form_response?.videos?.map((video: any) => (
              <a key={video?.id} href={video?.url} target="_blank" rel="noreferrer">
                Video
              </a>
            ))}
        </p>
      </div>
    </div>
  );
};

const PrintFormSection = (props: any) => {
  const {
    surveyId,
    installationId,
    visitId,
    form_sections: form_sections_data,
    printData,
    addToReportOnly,
    displayLinks,
    customerReport,
    displayCustomerScope
  } = props;

  const customerScopeSection = form_sections_data?.filter(
    (section: any) => section.position === 100
  )[0];

  let form_sections = form_sections_data;
  const installType = OldInstallTypeOptions.filter((x) => x.value === printData?.install_type)[0]
    ?.label;

  if (addToReportOnly) {
    const updatedFormSections = form_sections?.map((section: any) => {
      const add_to_report_form_questions: any = [];

      section?.form_questions?.forEach((question: any) => {
        if (question?.add_to_report) {
          add_to_report_form_questions.push(question);
        }
      });

      return { ...section, form_questions: add_to_report_form_questions };
    });

    const filteredFormSections = updatedFormSections?.filter(
      (section: any) => section.form_questions.length > 0
    );

    form_sections = filteredFormSections;
  }

  form_sections = form_sections.filter((section: any) => section.position !== 100);

  return (
    <div>
      <div className="logo_container">
        <h3 style={{ margin: 0, marginBottom: 10 }}>
          {surveyId
            ? "Site Feasibility Report"
            : installationId
              ? "Installation Report" + `${installType ? ` (${installType})` : ""}`
              : visitId ? "Complaint Visit report" : ""}
        </h3>
        <Logo className="form_svgLogo" />
      </div>

      {visitId ? <table className="print-table">
        <tbody>
          <tr className="table-row-1">
            <td>OBC Type</td>
            <td>{printData?.obc || "-"}</td>
            <td>Visit Date</td>
            <td>{printData?.visit_completed_at
              ? localizeDate(printData?.visit_completed_at
              ) : "-"}</td>
          </tr>
          <tr className="table-row-1">
            <td>Client</td>
            <td>{printData?.brand?.name || "-"}</td>
            <td>City</td>
            <td>{printData?.customer_city || "-"}</td>
          </tr>
          <tr className="table-row-1">
            <td>Installation No.</td>
            <td>{printData?.ecb_install_code || "-"}</td>
            <td>Customer Contact No.</td>
            <td>{printData?.contact_number || "-"}</td>
          </tr>
          <tr className="table-row-1">
            <td>Installation Date</td>
            <td>{printData?.
              actual_install_date_time
              ? localizeDate(printData?.
                actual_install_date_time
              ) : "-"}</td>
            <td>Complaint Number</td>
            <td>{printData?.ecb_complaint_code || "-"}</td>
          </tr>
          <tr className="table-row-1">
            <td>Visit Number</td>
            <td>{printData?.ecb_visit_code || "-"}</td>
            <td>Complaint Receive Date</td>
            <td>{printData?.complaint_receive_date ? localizeDate(printData?.complaint_receive_date) : "-"}</td>
          </tr>
          <tr className="table-row-1">
            <td>Previous Visit Date</td>
            <td>{printData?.
              previous_visit_date_time
              ? localizeDate(printData?.
                previous_visit_date_time
              ) : "-"}</td>
            <td>{"-"}</td>
            <td> {"-"}</td>
          </tr>
        </tbody>
      </table>
        :
        <table className="print-table">
          <tbody>
            <tr className="table-row-1">
              <td>Charger Type</td>
              <td>{printData?.obc || "-"}</td>
              <td>Date</td>
              <td>{printData?.approved_at ? localizeDate(printData?.approved_at) : "-"}</td>
            </tr>
            <tr className="table-row-1">
              <td>Client</td>
              <td>{printData?.brand?.name || "-"}</td>
              <td>City</td>
              <td>{printData?.customer_city || "-"}</td>
            </tr>
            <tr className="table-row-1">
              <td>Survey/Install No.</td>
              <td>{printData?.ecb_install_code || printData?.ecb_survey_code || "-"}</td>
              <td>Customer Contact No.</td>
              <td>{printData?.contact_number || "-"}</td>
            </tr>
          </tbody>
        </table>}
      <br />
      <table className="print-table">
        <tbody>
          <tr className="table-row-2">
            <td>Customer Name</td>
            <td>{printData?.customer_name}</td>
          </tr>
          <tr className="table-row-2">
            <td>Customer Address</td>
            <td>{printData && customerAddress(printData)}</td>
          </tr>
          <tr className="table-row-2">
            <td>Email</td>
            <td>{printData?.email}</td>
          </tr>
        </tbody>
      </table>

      <br />
      <table className="print-table">
        <thead>
          <tr>
            <th className="srno">SI. No.</th>
            <th className="head">Head</th>
            <th className="checkpoint">Check Point</th>
            <th className="response">Response</th>
            <th className="comment">Comment</th>
          </tr>
        </thead>
        <tbody>
          {form_sections?.map((section: any, index: number) => {
            const rows = section?.form_questions?.map((question: any, innerIndex: number) => (
              <tr key={innerIndex}>
                {innerIndex === 0 ? (
                  <>
                    <td rowSpan={section.form_questions.length} className="srno">
                      {index + 1}
                    </td>
                    <td rowSpan={section.form_questions.length} className="head">
                      {section?.name}
                    </td>
                  </>
                ) : null}
                <td className="checkpoint">
                  <CheckPoint
                    key={innerIndex}
                    section={section}
                    question={question}
                    index={innerIndex}
                  />
                </td>
                <td className="response">
                  <Response
                    key={innerIndex}
                    section={section}
                    question={question}
                    index={innerIndex}
                  />
                </td>
                <td className="comment">
                  {(displayLinks || question.add_to_customer_report && customerReport) && (
                    <Comment
                      key={innerIndex}
                      section={section}
                      question={question}
                      index={innerIndex}
                    />
                  )}
                </td>
              </tr>
            ));

            return rows;
          })}
        </tbody>
      </table>

      {displayCustomerScope && surveyId && customerScopeSection && (
        <>
          <br />
          <table className="print-table">
            <tbody>
              {customerScopeSection.form_questions?.map((question: any, innerIndex: number) => (
                <tr key={innerIndex}>
                  {innerIndex === 0 ? (
                    <>
                      <td rowSpan={customerScopeSection.form_questions.length} className="srno">
                        1
                      </td>
                      <td rowSpan={customerScopeSection.form_questions.length} className="head">
                        Customer Scope of Work
                      </td>
                    </>
                  ) : null}
                  <td className="checkpoint">
                    <CheckPoint
                      key={innerIndex}
                      section={customerScopeSection}
                      question={question}
                      index={innerIndex}
                    />
                  </td>
                  <td className="response">
                    <Response
                      key={innerIndex}
                      section={customerScopeSection}
                      question={question}
                      index={innerIndex}
                    />
                  </td>
                  <td className="comment">
                    {(displayLinks || question.add_to_customer_report && customerReport) && (
                      <Comment
                        key={innerIndex}
                        section={customerScopeSection}
                        question={question}
                        index={innerIndex}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      <br />
    </div>
  );
};

export default PrintFormSection;
